import { getLanguage } from "@Api/languageGet";
import { useUserContext } from "@Hooks/contexts/useUserContext";
import { setUserLanguage } from "@Utils/setUserLanguage";
import { changeLanguage } from "i18next";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
export function useInitialLanguage(token) {
    const setUser = useUserContext((s)=>s.setUser);
    const [language, setLanguage] = useState(useTranslation().i18n.language);
    useEffect(()=>{
        if (!token) return;
        try {
            getLanguage(token).then((lang)=>{
                setLanguage(lang);
                setUser(setUserLanguage(lang));
            });
        } catch (error) {
            console.error("Error fetching language:", error);
        }
    }, [
        token,
        setUser
    ]);
    useEffect(()=>{
        if (language) {
            changeLanguage(language);
        }
    }, [
        language
    ]);
}
